import React from 'react';

export const JobApplicationFormContext = React.createContext({
  updateElementMandatory: () => {},
});